import React, { PureComponent } from "react";

import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import filterFactory from "react-bootstrap-table2-filter";
import { getMetricForColumn, selectFormat } from "components/Utils/Utils";

class LeePriceChangeReport extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      hiddenRows: [],
      expandedRows: false,
      currentRowID: null,
    };
  }
  componentDidMount() {
    this.props.childRef(this);
    this.props.passRefUpward(this.childRef);
    this.setState({
      hiddenRows: this.props.data.data
        .filter((d) => d.period === "")
        .map((row) => row.id),
    });
  }

  renderTable(data) {
    const { cells, title, url } = this.props;

    data.forEach((d, i) => {
      d.id = i;
    });

    const showRows = (row) => {
      // Show specific rows
      let indexesToShow = [];

      for (let i = row.id + 1; i <= data.length - 1; i++) {
        if (data[i].period === "") {
          indexesToShow.push(i);
        } else {
          break;
        }
      }

      this.setState({
        hiddenRows: data
          .filter((d) => d.period === "")
          .map((row) => row.id)
          .filter((x) => !indexesToShow.includes(x)),
        expandedRows: true,
        currentRowID: row.id,
      });
    };

    const hideRows = (row) =>
      this.setState({
        hiddenRows: this.props.data.data
          .filter((d) => d.period === "")
          .map((row) => row.id),
        expandedRows: false,
        currentRowID: row.id,
      });

    const toggleRows = (row) => {
      this.setState({
        currentRowID: row.id,
      });

      if (
        row.id === this.state.currentRowID ||
        this.state.currentRowID === null
      ) {
        if (this.state.expandedRows) {
          hideRows(row);
        } else {
          showRows(row);
        }
      } else {
        if (this.state.expandedRows) {
          hideRows(row);
          showRows(row);
        } else {
          showRows(row);
        }
      }
    };

    const columns = [
      {
        dataField: "period",
        text: "Period",
        style: {
          width: "120px",
          minWidth: "120px",
          textAlign: "left",
        },
        headerAlign: "left",
        formatExtraData: {
          name: url.split("/")[2],
        },
        csvFormatter: (cell, row) => row && (row.period || row.period || ""),
        formatter: (cellContent, row) => {
          if (row.period > 0) {
            return (
              <>
                <button
                  onClick={() => toggleRows(row)}
                  className="toggleRowButton"
                >
                  <span>{row.period} ↓</span>
                </button>{" "}
              </>
            );
          }
        },
      },
      {
        dataField: "category",
        text: "Category",
        style: { width: "120px", minWidth: "120px", verticalAlign: "top" },
        csvFormatter: (cell, row) => row && row.category,
      },

      {
        dataField: "subscribers",
        text: "Subscribers",
        style: { width: "90px", minWidth: "90px", verticalAlign: "top" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
      },

      {
        dataField: "revenue",
        formatExtraData: { type: "currency" },
        text: "Revenue",
        style: { width: "90px", minWidth: "90px", verticalAlign: "top" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_currency", cell && cell.value, "$0,0.00"),
      },

      {
        dataField: "avg_weekly_rate",
        formatExtraData: { type: "currency" },
        text: "Avg Weekly Rate",
        style: { width: "90px", minWidth: "90px", verticalAlign: "top" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_currency", cell && cell.value, "$0,0.00"),
      },

      {
        dataField: "prior_period_rev",
        formatExtraData: { type: "currency" },
        text: "Prior Period Rev",
        style: { width: "90px", minWidth: "90px", verticalAlign: "top" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_currency", cell && cell.value, "$0,0.00"),
      },

      {
        dataField: "prior_period_avg_weekly_rate",
        formatExtraData: { type: "currency" },
        text: "Prior Period Avg Weekly Rate",
        style: { width: "90px", minWidth: "90px", verticalAlign: "top" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_currency", cell && cell.value, "$0,0.00"),
      },
    ];

    const rowStyle = (row) => {
      const style = {};

      if (row.period !== "") {
        style.backgroundColor = "#eee";
      }

      return style;
    };

    let selected_columns = columns;
    if (cells && cells.length) {
      selected_columns = [];
      cells.forEach((cell, i) => {
        selected_columns.push(columns.find((o) => o.dataField === cell));
      });
    }

    const filename = title.split(" ").join("_") || "spreadsheet";
    return (
      <ToolkitProvider
        keyField="id"
        data={data}
        columns={selected_columns}
        striped={false}
        hover={false}
        bordered={false}
        exportCSV={{
          fileName: filename + ".csv",
          exportAll: false,
          onlyExportFiltered: true,
        }}
      >
        {(props) => (
          <BootstrapTable
            {...props.baseProps}
            {...props.csvProps}
            hiddenRows={this.state.hiddenRows}
            rowStyle={rowStyle}
            filter={filterFactory()}
            ref={(el) => (this.childRef = el)}
          />
        )}
      </ToolkitProvider>
    );
  }

  builtInExportCSV = () => this.childRef;

  render() {
    const { data } = this.props;

    return this.renderTable(data.data);
  }
}

export default LeePriceChangeReport;
